var _circle, _circle2, _path, _circle3, _path2, _circle4, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F4F7FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0837,
    cy: 31.1667,
    r: 2.66667,
    stroke: "url(#paint0_linear_4712_32405)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 40.667C14.0139 39.0837 15.0167 35.917 16.9167 35.917C18.8167 35.917 21.9306 35.917 23.25 35.917C24.0417 35.917 25.7833 36.867 26.4167 40.667",
    stroke: "url(#paint1_linear_4712_32405)",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.9167,
    cy: 31.1667,
    r: 2.66667,
    stroke: "url(#paint2_linear_4712_32405)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.583 40.667C29.8469 39.0837 30.8497 35.917 32.7497 35.917C34.6497 35.917 37.7636 35.917 39.083 35.917C39.8747 35.917 41.6163 36.867 42.2497 40.667",
    stroke: "url(#paint3_linear_4712_32405)",
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9997,
    cy: 28.0007,
    r: 2.66667,
    stroke: "url(#paint4_linear_4712_32405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 35.917V17.917C13.75 17.3647 14.1977 16.917 14.75 16.917H41.25C41.8023 16.917 42.25 17.3647 42.25 17.917V35.917",
    stroke: "url(#paint5_linear_4712_32405)",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0833 39.084H32.75",
    stroke: "url(#paint6_linear_4712_32405)",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2503 39.084H16.917",
    stroke: "url(#paint7_linear_4712_32405)",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 34.3333C23.4762 33.8056 24.2 32.75 25.2857 32.75C26.3714 32.75 29.3571 32.75 30.7143 32.75C31.1667 32.75 32.2071 33.0667 32.75 34.3333",
    stroke: "url(#paint8_linear_4712_32405)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4712_32405",
    x1: 16.917,
    y1: 28,
    x2: 23.2503,
    y2: 34.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4712_32405",
    x1: 13.75,
    y1: 35.917,
    x2: 16.8733,
    y2: 44.2458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4712_32405",
    x1: 32.75,
    y1: 28,
    x2: 39.0833,
    y2: 34.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4712_32405",
    x1: 29.583,
    y1: 35.917,
    x2: 32.7063,
    y2: 44.2458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4712_32405",
    x1: 24.833,
    y1: 24.834,
    x2: 31.1663,
    y2: 31.1673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4712_32405",
    x1: 13.75,
    y1: 16.917,
    x2: 31.2885,
    y2: 43.2247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4712_32405",
    x1: 32.75,
    y1: 39.084,
    x2: 33.0581,
    y2: 41.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4712_32405",
    x1: 16.917,
    y1: 39.084,
    x2: 17.2251,
    y2: 41.0353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4712_32405",
    x1: 23.25,
    y1: 32.75,
    x2: 23.7635,
    y2: 35.8311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#023E8A",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.723958,
    stopColor: "#2684FF",
    stopOpacity: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.3834f9ea5f35e24478828ca27600207c.svg";
export { ForwardRef as ReactComponent };